<template>
	<div style="background-color: #f2f2f4;min-height: 100%;">
	  <Header title="重修报名选课" type="0" route="/homeIndex"></Header>
	  <div class="teachingProcess">
		<div class="list-head">
			<p>{{baseData.cxxq}}学期</p>
			<ul class="timeCss">
				<li><label>报名截止时间：{{baseData.bmkssj}}~{{baseData.bmjssj}}</label></li>
				<li><label>选课截止时间：{{baseData.xkkssj}}~{{baseData.xkjssj}}</label></li>
			</ul>
		</div>
		<NOdata
		  title="暂无数据~"
		  v-if="this.pageData && this.pageData.length == 0"
		></NOdata>
		<div class="content">
		  <div class="contentDiv" style="background-color: #fff"  v-for="(item, index) in pageData" :key="index" >
			<span class="xkspan" v-if="item.xkover=='1'">已选课</span>
			<span class="bmspan" v-else-if="item.bmover=='1'">已报名</span>
			<p>{{ item.kcmc }}</p>
			<ul>
			  <li>开课单位：{{ item.kkdw }}</li>
			  <li>重修报名类别：{{ item.kcsxname }}</li>
			</ul>
			<div class="xkrsmsgdiv">
				<div style="padding:0px;float: left;width: 33%;">学时：{{item.zxs}}</div>
				<div style="padding:0px;float: left;width: 33%;">学分：{{item.xf}}</div>
				<div style="padding:0px;float: left;width: 33%;">成绩：{{item.cjxs}}</div>
			</div>
			<div style="background-color:#fff;padding-right: 6% ;padding-top:0">

				<div v-if="item.bmflag=='1'" style="background-color: #7469f8;margin-left: 10px;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;color: #fff;padding: 0;text-align: center;float: right;" @click="goItem(item,'0')">
				报名
             </div>
			 <div v-if="item.xkflag=='1'" style="background-color: #7469f8;margin-left: 10px;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;color: #fff;padding: 0;text-align: center;float: right;" @click="goItem(item,'2')">
				选课
             </div>
			 <div  v-if="item.bmover=='1'&&item.xkover=='0'" style="background-color: #fff;margin-left: 10px;border: 1px solid rgb(116, 105, 248);color: rgb(116, 105, 248);;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;padding: 0;text-align: center;float: right;" @click="goItem(item,'1')">
				取消报名
             </div>
			 <div  v-if="item.xkover=='1'" style="background-color: #fff;margin-left: 10px;border: 1px solid rgb(116, 105, 248);color: rgb(116, 105, 248);;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;padding: 0;text-align: center;float: right;" @click="goItem(item,'3')">
				退课
             </div>
			</div>
		</div>
		  </div>
		 
	  </div>
	  <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469F8"
      inactive-color="#B3B9D0"
      route
    >
      <van-tabbar-item  class="van-icon-like-o" replace to="/student/cxCuarChoose">
        <span class="nav-title">报名选课</span>
      </van-tabbar-item>
      <van-tabbar-item class="van-icon-like" replace to="/student/cxCuarChooseHistory">
        <span class="nav-title">选课记录</span>
      </van-tabbar-item>
    </van-tabbar>
	  <van-dialog
      v-model="show"
      :title="messageTittle"
      show-cancel-button
      show-confirm-button
      @cancel="show=false"
      @confirm="dialogConfirm"
    >
      <div class="wpjs-detail-message-box">
        {{message}}
      </div>
    </van-dialog>
	  
	</div>
  </template>
  
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		show1: false,
		active: 0,
		title: "",
		show: false,
		cloumList:[],
		baseData:{},
		cxxq:'',
		cxid:'',
		kcid:'',
		conperType :'',
		messageTittle:'',
		tzdid:'',
		message:''

	  };
	},
	methods: {
	  goItem(item,type) {
		//this.$router.push({
		  //path: "/teacher/jxjdgl_deallist",
		 // query: {
			//jx0404id:item.jx0404id,
			//itemObj:JSON.stringify(item)
		  //}
		//});
		this.cxid = item.cj0721id;
		this.kcid = item.kcid;
		this.conperType = type;
		if(type=='0'){
			this.show = true;
			this.messageTittle = '确认报名';
			this.message='您是否确认报名该课程？';
		}else if(type=='1'){
			this.show = true;
			this.messageTittle = '确认取消报名';
			this.message='您是否确认取消报名该课程？';
		}else if(type=='2'){
			this.$router.push({
		     path: "/student/cxCuarChooseList",
		     query: {
				cxid:item.cj0721id,
				kcid:this.kcid
		     }
		  });
		}else if(type=='3'){
			this.tzdid = item.jx0404id;
			this.show = true;
			this.messageTittle = '确认退课';
			this.message='您是否确认退选该课程？';
		}

	  },
	  async initData(){
		const res = await Api.cxXkKc_query()
		if (res.code == '1') {
			this.pageData = res.data
			this.baseData = res.heardData
		} else {
			this.$toast(res.Msg)
		}
		},
		async cxXkKc_bm(){
			const parm = {
				cxid:this.cxid
			};
			const res = await Api.cxXkKc_saveBm(parm);
			if(res.code=='1'){
				this.$toast("报名成功！");
				setTimeout(() => {   
					this.initData();
				}, 1500);
			}else if(res.code=='2'){
				this.$toast(res.Msg);
			}
		},
		async cxXkKc_cancle(){
			const parm = {
				cxid:this.cxid
			};
			const res = await Api.cxXkKc_cancleBm(parm);
			if(res.code=='1'){
				this.$toast("取消报名成功！");
				setTimeout(() => {   
					this.initData();
				}, 1500);
			}else if(res.code=='2'){
				this.$toast(res.Msg);
			}
		},
		async cxXkKc_tk(){
			const parm = {
				cxid:this.cxid,
				tzdid:this.tzdid
			};
			const res = await Api.cxXkKc_cancleXk(parm);
			if(res.code=='1'){
				this.$toast("退课成功！");
				setTimeout(() => {   
					this.initData();
				}, 1500);
			}else if(res.code=='2'){
				this.$toast(res.Msg);
			}
		},
		dialogConfirm(){
			this.show = false;
			if(this.conperType=='0'){
				this.cxXkKc_bm();
			}else if(this.conperType=='1'){
				this.cxXkKc_cancle();
			}else if(this.conperType=='3'){
				this.cxXkKc_tk();
			}
			
		}
	},
	created() {
		this.initData();
	}
  };
  </script>
  <style scoped lang="less" >
  .teachingProcess-head{
	padding: 3% 5% 10px;
	background-color: #fff;
	height: 30px;
	padding-right: 10px ;
  }
  .teachingProcess {
	padding: 3% 5% 0;
	background-color: #f2f2f4;
	height: 100%;
	.list-head {
	  height: auto;
	  background-image: url('~@/assets/images/assessment/cell--bg.png'), linear-gradient(0deg, #7368ff 0%, #8e85ff 100%);
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  border-radius: 8px;
      box-shadow: 0 2px 10px 0 #3323ff59;
	  p {
		height: 14px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		font-weight: lighter;
		margin-bottom: 10px;
	  }
	}
  
	.timeCss{
		ul{
         list-style:none;
		 padding: 0;
		 font-family: PingFangSC-Medium;
         font-size: 13px;
		 font-weight: lighter;
		 margin-top:10px ;
	  }
	  li{
		//display: inline-block;
		position: relative;
		color: #ffffff;
		font-family: PingFangSC-Medium;
         font-size: 10px;
		 font-weight: lighter;
		 label{
			padding-left:12px;
		 }
		 margin-bottom: 5px;
	  }
	  li:before{
		content: '';
		position: absolute;
		left: 3px;
		top: 50%;
		-webkit-transform:translateY(-50%) ;
		transform: translateY(-50%);
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background-color: #fff;
	  }
	  li:first{
		
	  }
	  li:first-child:after{
		content: '';
		position: absolute;
		left: 6px;
		top: 10px;
		bottom: 0;
		height: 18px;
		width: 1px;
		
		border-left: 1px solid #fff;
	  }
	}

	.content {
		margin-top: 10px;
	  div {
		background: #f2f2f4;
		border-radius: 5px;
		padding: 3% 0 3% 6%;
		margin-bottom: 5%;
		position: relative;
  
		p {
		  height: 22px;
		  font-family: PingFangSC-SNaNpxibold;
		  font-size: 16px;
		  color: #333333;
		  letter-spacing: 0;
		  font-weight: 600;
		  margin-bottom: 2%;
		}
  
		ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  font-weight: 400;
		}
		span {
		  position: absolute;
		  top: 0px;
		  right: 0px;
		  display: block;
		  width: 56px;
		  height: 24px;
		  border-radius: 0 8px 0 8px ;
		  font-size: 14px;
		  line-height: 20px;
		  padding-top: 2px;
		  padding-left: 10px;
		}
		.bmspan{
			background: #41b29c26;
			color: #41B29C;
		}
		.xkspan{
			background: #b26e4142;
			color: red;
		}
	  }
	}
	
  }
  .more.van-popup.van-popup--bottom {
	border-radius: 0 !important ;
  }
  .more {
	padding: 5% 0 5% 0;
	box-sizing: border-box;
	overflow: hidden;
	.van-tabs__content--animated {
	  height: 75vh;
	  overflow: auto;
	}
	.van-tabs--line .van-tabs__wrap {
	  border-bottom: 1px solid #f4f4f4;
	  .van-tab--active {
		.van-tab__text--ellipsis {
		  color: #212f6e !important;
		}
	  }
	  .van-tab__text--ellipsis {
		height: 20px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #8f95b5;
		text-align: center;
		letter-spacing: 0;
	  }
	  .van-tabs__line {
		background-color: #7469f8 !important;
		width: 25px;
		height: 3px;
		border-radius: 1.5px;
	  }
	}
	& > p {
	  width: 64px;
	  font-weight: bolder;
	  font-family: PingFangSC-Medium;
	  font-size: 16px;
	  color: #000000;
	  letter-spacing: 0;
	  text-align: center;
	  padding-left: 7%;
	}
	ul {
	  overflow: auto;
	  height: 36vh;
	  .choose {
		background-color: #f2f2f4;
	  }
	  li {
		height: 40px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #212f6e;
		font-weight: bold;
		display: flex;
		align-items: center;
		padding-right: 5%;
		padding-left: 7%;
		justify-content: space-between;
	  }
	}
  }

  .contentDiv{
		background-color: #fff;
	}
	.xkrsmsgdiv{
		margin-right:6% ;
		margin-top: 10px;
		height: 25px;
		font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  font-weight: 400;
	}
	.lrbutomdiv{
		background-color: #7469f8;
		height: 30px;width: 80px;
		line-height: 30px;
		border-radius: 16px;
		color: #fff;
		padding: 0;
		text-align: center;
		margin-left: calc(100%-80px);
		
	}

	/deep/.wpjs-detail-message-box {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;

  .red {
    color: red;
  }
}

.bottom-nav {
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 19px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-tabbar-item__text{
	margin: 0;
	span{
		font-size: 14px;
		
	}
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }
}

  </style>
  


// WEBPACK FOOTER //
// src/components/student/cxCuarChoose/cxCuarChooseIndex.vue